import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { createProductUrl } from '~/components/CategoryBlocks/utils';
import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { CDPrice as Price } from '~/components/Price/CDPrice';
import { formatVolume } from '~/components/ProductCard/utils';
import type { ProductViewProps } from '~/pages/Product/Product';
import { pluralize } from '~/utils/pluralize';

import styles from './ListOfItems.module.scss';

const ListOfItems = ({ product }: Pick<ProductViewProps, 'product'>) => {
  const { t } = useTranslation();

  const offers = product.data?.offers ?? [];

  const getQtyDeclension = (qty: Nullable<number>) => {
    if (typeof qty !== 'number') {
      return '';
    }

    return `${qty} ${pluralize(qty, [t('item'), t('items_few'), t('items')])}`;
  };

  return (
    <div className={styles.root}>
      {offers.map((offer) => (
        <Link
          key={offer.id}
          to={createProductUrl({ id: offer.productSlug || offer.slug })}
          className={styles.offer}
        >
          <div className={styles.imgWr}>
            <CloudflareResponseImage
              src={offer.previewImageThumb || ''}
              srcParams={{ width: 100, height: 140 }}
              srcSetParams={defaultSrcSetParams}
              className={styles.bundleList_contentItem_image}
              loading="lazy"
              alt=""
            />
          </div>
          <div className={styles.content}>
            <h3 className={styles.title} title={offer.name}>
              {offer.name}
            </h3>
            <span className={styles.volume}>
              {formatVolume(offer.properties)}
            </span>
            <Price
              discountPercent={offer.discountPercentage}
              discount={
                offer.discountPrice &&
                offer.discountPriceFormatted !== offer.priceFormatted
                  ? offer.priceFormatted
                  : undefined
              }
              price={
                offer.discountPrice &&
                offer.discountPriceFormatted !== offer.priceFormatted
                  ? offer.discountPriceFormatted
                  : offer.priceFormatted
              }
              classes={{
                classNameCurrentPrice: styles.price,
                classNameOldPrice: styles.oldPrice,
              }}
            />
          </div>
          <span className={styles.qty}>
            {getQtyDeclension(offer.bundleQuantity)}
          </span>
        </Link>
      ))}
    </div>
  );
};

export default observer(ListOfItems);
